export default "__VITE_ASSET__DXOcEll6__"